const DRAWING_COMMIT = 'editable:drawing:commit';

export { DRAWING_COMMIT };
